import { createContext, useCallback, useState } from "react";

export const SavedIcon = createContext()

/**
 * De waarde waar `components/common/Snackbar.jsx` op reageert. Een andere
 * waarde zet de state wel, maar toont niets.
 */
const VISIBLE = 'flex'

export const SavedProvider = (props) => {
    const [saved, setSavedState] = useState("none")
    // Optional one-off message for the snackbar; '' means none. Display and
    // dismiss timing live in components/common/Snackbar.jsx.
    const [savedMessage, setSavedMessage] = useState("")

    /**
     * Zet de snackbar-stand, en vertaalt `true` naar 'flex'.
     *
     * Er staan 59 aanroepen van `setSaved(true)` in 11 bestanden — onder meer
     * bij het versturen van een teamuitnodiging. Die zetten de state wel, maar
     * de snackbar keek alleen naar 'flex', dus de gebruiker kreeg na een
     * geslaagde schrijfactie géén bevestiging terwijl de code de indruk wekt
     * van wel. Twee schrijfwijzen voor één waarde, met niets dat ze bij elkaar
     * hield. Het normaliseren gebeurt hier, op de enige plek waar de waarde
     * binnenkomt, in plaats van op 59 aanroepen: dan werkt een toekomstige
     * `setSaved(true)` ook gewoon.
     * AI-CONTEXT: See docs/pitfalls.md#dev-mirrored-constant-guarded-only-by-a-comment
     *
     * @param {'flex' | 'none' | true} value - Gewenste stand van de snackbar
     */
    const setSaved = useCallback((value) => {
        setSavedState(value === true ? VISIBLE : value)
    }, [])

    return(
        <SavedIcon.Provider value={[saved, setSaved, savedMessage, setSavedMessage]}>
            {props.children}
        </SavedIcon.Provider>
    )
}
